// How a name printed on a manual reads on screen.
//
// Manuals shout. Packaging is set in ALL CAPS and the model quotes what it sees, so
// the answer is faithful and unreadable — a table of BARREL NUT / CHIPBOARD SCREW /
// ALLEN KEY is a row of shouting. Nothing here touches the stored value: that is the
// manual's own text, and this is only how it is read.

// Display a brand name in title case — first letter of each word capitalized, the
// rest lower — so a value the model reads off packaging in ALL CAPS (e.g.
// "RENDEZ VOUS DECO") shows as "Rendez Vous Deco". Whitespace is preserved.
export function formatBrand(brand: string): string {
  return (brand || '')
    .split(/(\s+)/)
    .map((w) => (/^\s+$/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()))
    .join('');
}

// A part's printed name, unshouted: "BARREL NUT" -> "Barrel nut", "ALLEN KEY" ->
// "Allen key". Sentence case, not the brand's title case — these are common nouns.
//
// Only an ALL-CAPS name is touched. A manual that prints "Barrel nut" has already made
// its choice, and re-casing that could only make it worse.
//
// A word carrying a digit is left exactly as printed ("70MM", "M6", "T25"): those are
// codes, and a code is not shouting. Pure-letter acronyms are the honest limit here —
// "PVC SCREW DRIVER" becomes "Pvc screw driver", because nothing short of a dictionary
// tells PVC from BARREL. A row of readable names with one flattened acronym beats a row
// that shouts.
export function formatPartName(name: string): string {
  const v = (name || '').trim();
  // A lowercase letter anywhere means it is not shouting.
  if (!v || /[a-z]/.test(v)) return v;
  const lowered = v
    .split(/(\s+)/)
    .map((w) => (/\d/.test(w) ? w : w.toLowerCase()))
    .join('');
  return lowered.charAt(0).toUpperCase() + lowered.slice(1);
}
